import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  getLimitsCustomerAmountService,
  getLimitsCustomerPaymentService,
  setLimitsCustomerAmountService,
  setLimitsCustomerPaymentService,
  setLimitsOperationsDataService,
  setLimitsUsersDataService,
} from '../services/limits.service';
import {
  TSetLimitsCustomerAmountDataRequest,
  TSetLimitsCustomerPaymentDataRequest,
  TSetLimitsOperationsDataRequest,
  TSetLimitsUsersDataRequest,
} from '../types/limits.types';

export const useGetLimitsUsersDataQuery = (
  counterpartyGUID: string,
  options?: any
): UseQueryResult<any> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.LimitsQueryKeys].getLimitsUsersData(counterpartyGUID),
    ...options
  });

export const useSetLimitsUsersMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; requestData: TSetLimitsUsersDataRequest }) =>
      setLimitsUsersDataService(data.counterpartyGUID, data.requestData),
  });

export const useGetLimitsOperationsDataQuery = (
  counterpartyGUID: string,
  options?: any
): UseQueryResult<any> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.LimitsQueryKeys].getLimitsOperationsData(counterpartyGUID),
    ...options
  });

export const useSetLimitsOperationsMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; requestData: TSetLimitsOperationsDataRequest }) =>
      setLimitsOperationsDataService(data.counterpartyGUID, data.requestData),
  });

export const useGetLimitsCustomerAmountMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string, params: { customer_guid: string } }) =>
      getLimitsCustomerAmountService(data.counterpartyGUID, data.params),
  });

export const useSetLimitsCustomerAmountMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string, requestData: TSetLimitsCustomerAmountDataRequest }) =>
      setLimitsCustomerAmountService(data.counterpartyGUID, data.requestData),
  });

export const useGetLimitsCustomerPaymentMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string, params: { customer_guid: string } }) =>
      getLimitsCustomerPaymentService(data.counterpartyGUID, data.params),
  });

export const useSetLimitsCustomerPaymentMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string, requestData: TSetLimitsCustomerPaymentDataRequest }) =>
      setLimitsCustomerPaymentService(data.counterpartyGUID, data.requestData),
  });
